import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { useSalesforceSync } from '@hooks';

export interface SyncNowButtonProps {
	disabled?: boolean;
	id?: string;
}

export const SyncNowButton: React.FC<SyncNowButtonProps> = ({ disabled, id = 'sync-now-button' }) => {
	const { isRequested, isSyncing, startSync } = useSalesforceSync();

	return (
		<Button
			disabled={ disabled || isRequested || isSyncing }
			id={ id }
			onClick={ startSync }
			type='primary'>
			<SyncOutlined spin={ isSyncing } /> { COPY_SPECIFIC.SYNC_NOW }
		</Button>
	);
};
